<template>
    <unit-test-job :jobType="jobType" :activeTab="activeTab" :iframeSrc="iframeSrc" v-model="yamlContent" :advancedProps="advancedProps"></unit-test-job>
</template>

<script>
import UnitTestJob from './UnitTestJob.vue';

export default {
    components: { UnitTestJob },
    data() { 
        return {
            jobType: "MapperV2",
            activeTab: this.$store.state.sandboxUnitTest.mapperV2ActiveTab,
            yamlContent: this.$store.state.sandboxUnitTest.mapperV2YamlList,
            advancedProps: this.$store.state.sandboxUnitTest.mapperV2AdvancedProps,
            iframeSrc: `${this.$store.state.docsUrl}/docs/amdp/services/data-integration-service/mapper-v2/examples.html`    
        };
    },    
    watch: {        
        'yamlContent.config': {
            handler (newVal) {
                this.$store.dispatch("sandboxUnitTest/setMapperV2ConfigYaml", newVal);
            }
        }
    }, 
       
};
</script>

<style scoped>
</style>